import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { returnsCenterLocationSchema } from "./get-managed-returns-metrics";

export const getManagedReturnsLocations = unaryRpc({
  name: "getManagedReturnsLocations" as const,
  input: z.object({}),
  output: z.object({
    returnsCenterLocations: z.array(returnsCenterLocationSchema),
  }),
});

export type ManagedReturnsLocationsOutput = z.infer<
  (typeof getManagedReturnsLocations)["output"]
>;
